window.addEventListener('load', function () {
  var fixedPopups = document.querySelectorAll('.fixed-popup');
  if (fixedPopups.length > 0) {
    const evidenceBasedBtn = document.getElementById('evidenceBasedBtn');
    evidenceBasedBtn.addEventListener('click', function(e) {
      e.preventDefault();
      fixedPopups.forEach(function(popup) {
        popup.classList.add('active');
      });
    });

    document.querySelectorAll('.close-wrap').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        fixedPopups.forEach(function(popup) {
          popup.classList.remove('active');
        });
      });
    });

    fixedPopups.forEach(function(popup) {
      popup.addEventListener('click', function(e) {
        if (e.target === popup) {
          popup.classList.remove('active'); 
        } 
      });
    });
  }
});